import useWidth from '../../../../../../../../../../components/Hooks/useWidth';
import { PackQuantitiesWithMultiplier } from '../../../../../../../../../../services/modules/product-colors-packs/product-colors-packs.types';
import PacksMenuItemDesktop from './desktop/PacksMenuItemDesktop';
import PacksMenuItemMobile from './mobile/PacksMenuItemMobile';

interface PacksMenuItemProps {
  pack: PackQuantitiesWithMultiplier;
  isPackSelected: boolean;
  isPackWithError: boolean;
  onClickRow: (quantity: number) => void;
  onClickGridMultiply: (multiplier: number) => void;
  isPackWithUnavailableStock: boolean;
  itemWidth: number;
}

const PacksMenuItem = ({
  pack,
  onClickRow,
  isPackSelected,
  isPackWithError,
  onClickGridMultiply,
  isPackWithUnavailableStock,
  itemWidth,
}: PacksMenuItemProps) => {
  const { mobileWidth } = useWidth();

  return mobileWidth ? (
    <PacksMenuItemMobile
      pack={pack}
      itemWidth={itemWidth}
      onClickRow={onClickRow}
      isPackSelected={isPackSelected}
      isPackWithError={isPackWithError}
      onClickGridMultiply={onClickGridMultiply}
      isPackWithUnavailableStock={isPackWithUnavailableStock}
    />
  ) : (
    <PacksMenuItemDesktop
      pack={pack}
      itemWidth={itemWidth}
      onClickRow={onClickRow}
      isPackSelected={isPackSelected}
      isPackWithError={isPackWithError}
      onClickGridMultiply={onClickGridMultiply}
      isPackWithUnavailableStock={isPackWithUnavailableStock}
    />
  );
};

export default PacksMenuItem;
